<template>
  <div>
    <b-table-simple responsive="sm" class="table my-2">
      <b-thead>
        <b-tr>
          <b-th scope="col">Category</b-th>
          <b-th scope="col">Score</b-th>
          <b-th scope="col">Action</b-th>
        </b-tr>
      </b-thead>

      <b-tbody>
        <b-tr v-for="(cloenFields,index) in CVIPInput" :key="index">
          <b-td>
            <b-form-group :invalid-feedback="showAddRowError">
              <b-form-input
                v-model="$store.state.priConfigrationforms.sanctions.CVIPCategoryValue[index]"
                type="text"
                size="sm"
                @input="checkAddRowValidation"
                :state="getValidationColor ? false : null"
              ></b-form-input>
            </b-form-group>
          </b-td>
          <b-td>
            <b-form-group :invalid-feedback="showAddRowError">
              <b-form-input
                onkeydown="return event.keyCode !== 69"
                v-model="$store.state.priConfigrationforms.sanctions.CVIPScoreValue[index]"
                type="number"
                size="sm"
                :state="getValidationColor ? false : null"
                min="31"
                max="75"
              ></b-form-input>
            </b-form-group>
          </b-td>
          <b-td style="padding-top: 0px;">
            <b-button
              variant="outline-danger"
              size="sm"
              v-if="index > 0"
              @click="onDeleteOption(index)"
            >
              <i class="fa fa-trash"></i>
            </b-button>
          </b-td>
        </b-tr>
        <b-tr>
          <b-td>
            <b-button @click="addRowInCVIPTable">Add Row</b-button>
          </b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
  </div>
</template>
<script>
export default {
  name: "AddRowComponent",
  data() {
    return {
      CVIPInput: [1],
      showAddRowError: null,
      addRowFormValueValidation: true,
      getValidationColor: false
    };
  },
  mounted() {
    if (
      this.$store.state.priConfigrationforms.sanctions.CVIPCategoryValue
        .length > 0
    ) {
      this.$store.state.priConfigrationforms.sanctions.CVIPCategoryValue.map(
        (data, index) => {
          this.CVIPInput.push(index);
        }
      );
    }
  },
  computed: {},
  methods: {
    checkAddRowValidation() {
      this.addRowFormValueValidation = false;
      this.getValidationColor = false;
    },
    addRowInCVIPTable() {
      if (this.addRowFormValueValidation) {
        this.getValidationColor = true;
        this.showAddRowError = "Please Fill Value First";
      } else if (this.addRowFormValueValidation == false) {
        this.addRowFormValueValidation = true;
        this.CVIPInput.push(1);
      }
    },
    onDeleteOption(index) {
      this.CVIPInput.splice(this.CVIPInput.indexOf(index), 1);
    }
  }
};
</script>